/// <reference types="vite/client" />
// The compiled ink scripts (content/dialogue/compiled/<name>.json, written by `content:gen` from content/dialogue/*.ink
// with inkjs's compiler; `content:check` fails a stale one), bundled as text for the ink runner.
const FILES = import.meta.glob<string>("../../content/dialogue/compiled/*.json", { eager: true, query: "?raw", import: "default" });

/** Every compiled script by name. */
export function compiledScripts(): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [path, text] of Object.entries(FILES)) out[path.slice(path.lastIndexOf("/") + 1, -".json".length)] = text;
  return out;
}
